export default __webpack_public_path__ + "static/media/content-boxes_bcg.f1c03ad3.svg";